const initialState = {
  bundleLoaderUrl: new URL(`${window.env.BUNDLE_LOADER_PROTOCOL}://${window.env.BUNDLE_LOADER_DOMAIN}`),
  bwApiRootUrl: new URL(window.env.BW_API_ROOT_URL),
  imageCheckRootUrl: new URL(window.env.IMAGE_CHECK_ROOT_URL)
};

export function config(state = initialState, action) {
  switch (action.type) {
  default:
    return state;
  }
}
